import React from "react";
import "../styles/Valuation.css";

export default function Valuation() {
  return (
    <div className="page-container">
      <h1 className="page-title">Car Valuation</h1>

      <h2 style={{ color: "#003566", marginTop: "20px" }}>
        🚧 Coming Soon
      </h2>

      <p style={{ marginTop: "10px", color: "#666" }}>
        This feature will be available soon. Stay tuned!
      </p>
    </div>
  );
}